import action from 'app/lib/action';
import {DELETE_UNIT} from '../constants/actionTypes';

export default {
    request : (vtrac, utrac) => action(DELETE_UNIT.REQUEST)({vtrac, utrac}),
    success : (trac, vtrac) => action(DELETE_UNIT.SUCCESS)({trac, vtrac}),
    error   : (error) => action(DELETE_UNIT.ERROR)({error})
};